import script from "./AddMetadata.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddMetadata.vue?vue&type=script&lang=ts&setup=true"

import "./AddMetadata.vue?vue&type=style&index=0&id=db25b69e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db25b69e"]])

export default __exports__